import { useEffect, useState } from 'react'
import { FormatCountdown } from '../components/Countdown/Countdown.types'

interface OptionsCountdown {
  interval?: number
  format?: FormatCountdown
}

const useCountdown = (
  targetDate: Date,
  { format = 'dd:hh:mm:ss', interval = 1000 }: OptionsCountdown,
) => {
  const countDownDate = new Date(targetDate).getTime()
  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime())

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
    }, interval)

    return () => clearInterval(timeInterval)
  }, [countDownDate])

  return getReturnValues(countDown, format)
}

const parsedTime = (value: number, parentTime?: number, inHours?: boolean): string => {
  if (inHours && parentTime >= 1) {
    return String(value + parentTime * 24)
  }
  return value < 10 ? `0${value}` : String(value)
}

const getReturnValues = (countDown: number, format: FormatCountdown) => {
  const inUnits = format.split(':')[0]

  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000)
  const isExpired = days + hours + minutes + seconds <= 0

  return {
    days: parsedTime(days),
    hours: parsedTime(hours, days, inUnits === 'hh'),
    minutes: parsedTime(minutes, (days || 1) * hours, inUnits === 'mm'),
    seconds: parsedTime(
      seconds,
      minutes * (minutes || 1) * (hours || 1) * (days || 1),
      inUnits === 'ss',
    ),
    isExpired,
  }
}

export { useCountdown }
